import logoUrl from "@/views/assets/images/logo-text.svg";

/** 管理后台品牌标识，保持旧 Vue 的 155×40 组合标识尺寸。 */
export function LogoTextSvgIcon() {
    return (
        <div className="logo-text-icon" aria-label="链云砂石">
            <img src={logoUrl} alt="链云砂石" />
        </div>
    );
}

export default LogoTextSvgIcon;
